import EventBus from "@packages/event-bus";
import LeaderLine from "leader-line";
import _ from "lodash";
import provider from "@mixins/provider";
import colors from "@mixins/colors";
import palette from "@packages/colors";

export default {
  data() {
    return {
      links: [],
      activeOption: null,
      activeInteraction: null,
      hoveredInteractionId: null,
      option: null,
    };
  },

  mixins: [provider, colors],

  props: {
    dataMode: {
      type: String,
      required: true,
    },

    dataInteraction: {
      type: Object,
      required: true,
    },
  },

  computed: {
    options() {
      return this.dataInteraction.opcoes;
    },

    mode() {
      return this.dataMode;
    },

    isLinkMode() {
      return this.mode === "LINK";
    },

    canLink() {
      return this.isLinkMode && this.links.length === 0;
    },

    canCloseLink() {
      return (
        this.isLinkMode &&
        this.interaction.proximaInteracaoId &&
        this.links.length > 0
      );
    },

    interaction() {
      return this.dataInteraction;
    },

    interactions() {
      return this.$store.state.interactions.interactionElements;
    },

    nextInteractions() {
      return _.filter(this.interactions, (interactionElement) => {
        return (
          interactionElement.interaction.posicaoX > this.interaction.posicaoX
        );
      });
    },

    isShowingLinks() {
      return this.links.length > 0;
    },
  },

  methods: {
    async clearConnections(event, option, interaction) {
      event.stopPropagation();

      if (this.activeOption) {
        await this.deleteLink(this.activeOption);
      }

      if (interaction) {
        await this.deleteCloseLink();
      }

      return this.clearLinks();
    },
    hasActiveLinks({ interaction }) {
      const isOption = !!this.activeOption;
      const isInteraction = !!interaction && !!this.activeInteraction;

      if (isOption) {
        return !!this.activeOption.proximaInteracaoId;
      }

      if (isInteraction) {
        return (
          this.activeInteraction.id === interaction.id &&
          !!this.activeInteraction.proximaInteracaoId
        );
      }
    },
    async showLinks({ event, option, interaction }) {
      if (!this.isLinkMode) {
        return;
      }

      EventBus.$emit("CLEAR-ALL-LINKS", option);

      // if (this.option && !this.canLink) {
      //     await this.deleteLink(option);
      //     return this.clearLinks();
      // }

      // if (!option && this.canCloseLink) {
      //     await this.deleteCloseLink();
      //     return this.clearLinks();
      // }

      this.activeOption = this.options[event.target.attributes.id.value];
      this.activeInteraction = interaction;

      _.forEach(this.nextInteractions, (obj) => {
        const link = new LeaderLine(event.target, obj.element);
        this.links.push({
          line: link,
          to: obj,
        });
        this.setStyles();
      });
    },
    async deleteCloseLink() {
      const payload = {
        interactionId: this.interaction.id,
        advertisingId: this.interaction.campanhaId,
      };
      await this.$api.interactions.unbindInteraction(payload);
      this.dataInteraction.proximaInteracaoId = undefined;
      EventBus.$emit("show-message", {
        type: "SUCCESS",
        message: "Interação desconectada!",
        timeout: 3500,
      });
    },
    async deleteLink() {
      const selected = this.activeOption
        ? this.activeOption
        : this.activeInteraction;

      if (this.activeOption && selected.proximaInteracaoId) {
        const payload = {
          optionId: this.activeOption ? this.activeOption.id : null,
          interactionId: this.activeInteraction.id,
          advertisingId: this.activeInteraction.campanhaId,
        };
        await this.$api.interactions.options.unbindInteraction(payload);
        this.activeOption.proximaInteracaoId = undefined;
        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: "Interação desconectada!",
          timeout: 3500,
        });
      }
    },
    clearLinks() {
      _.forEach(this.links, (link) => {
        link.line.remove();
      });
      this.links = [];
      this.activeOption = null;
      this.activeInteraction = null;
      this.hoveredInteractionId = null;
    },

    refreshPosition() {
      _.forEach(this.links, (link) => {
        link.line.position();
      });
    },

    async setNextInteraction(nextId) {
      const payload = {
        optionId: this.activeOption ? this.activeOption.id : null,
        interactionId: this.activeInteraction.id,
        advertisingId: this.activeInteraction.campanhaId,
        nextId,
      };

      try {
        if (this.activeOption) {
          await this.$api.interactions.options.bindInteraction(payload);
          this.activeOption.proximaInteracaoId = nextId;
        } else {
          await this.$api.interactions.bindInteraction(payload);
          this.activeInteraction.proximaInteracaoId = nextId;
        }

        return this.success();
      } catch (e) {
        this.clearLinks();
      }
    },

    success() {
      this.clearLinks();
      EventBus.$emit("show-message", {
        type: "SUCCESS",
        message: "Interação conectada!",
        timeout: 3500,
      });
    },

    setStyles() {
      _.forEach(this.links, (link) => {
        let dash = { animation: true };
        let color = "#C8C8C8";
        const selected = this.activeOption
          ? this.activeOption
          : this.activeInteraction;

        if (
          selected.proximaInteracaoId &&
          selected.proximaInteracaoId === link.to.interaction.id
        ) {
          color = this.getColor(palette.primary);
          dash = false;
        }

        if (this.hoveredInteractionId === link.to.interaction.id)
          color = this.getColor(palette.primary);

        link.line.dash = dash;
        link.line.color = color;
      });
    },
    linkInteractionHandler(interactionId) {
      if (
        !this.activeInteraction ||
        this.activeInteraction.id === interactionId
      )
        return;

      this.setNextInteraction(interactionId);
    },
    intercationMouseEnterHandler(interactionId) {
      this.hoveredInteractionId = interactionId;
      this.setStyles();
    },
    intercationMouseLeaveHandler(interactionId) {
      if (this.hoveredInteractionId !== interactionId) return;

      this.hoveredInteractionId = null;
      this.setStyles();
    },
    clearAllLinksHandler(option) {
      if (this.activeOption !== option) this.clearLinks();
    },
    clearColoseBtnLinks() {},
  },

  watch: {
    isLinkMode(val) {
      if (!val) this.clearLinks();
    },
  },

  mounted() {
    EventBus.$on("SCROLL", this.refreshPosition);

    EventBus.$on("LINK-INTERACTION", this.linkInteractionHandler);

    EventBus.$on("INTERACTION-MOUSE-ENTER", this.intercationMouseEnterHandler);

    EventBus.$on("INTERACTION-MOUSE-LEAVE", this.intercationMouseLeaveHandler);

    EventBus.$on("CLEAR-ALL-LINKS", this.clearAllLinksHandler);
  },

  beforeDestroy() {
    EventBus.$off("SCROLL", this.refreshPosition);

    EventBus.$off("LINK-INTERACTION", this.linkInteractionHandler);

    EventBus.$off("INTERACTION-MOUSE-ENTER", this.intercationMouseEnterHandler);

    EventBus.$off("INTERACTION-MOUSE-LEAVE", this.intercationMouseLeaveHandler);

    EventBus.$off("CLEAR-ALL-LINKS", this.clearAllLinksHandler);
  },

  destroyed() {
    this.clearLinks();
  },
};
